import React, { Component } from 'react';
import ReactDOM from 'react-dom';
const modalId = document.getElementById('homepage-modal');

class HomepageModalWrapper extends Component {
  constructor(props) {
    super(props);
    this.el = document.createElement('div');
  }
  componentDidMount() {
    modalId.appendChild(this.el);
  }
  componentWillUnmount() {
    modalId.removeChild(this.el);
  }
  render() {
    return ReactDOM.createPortal(
      this.props.children,
      this.el,
    );
  }
}

export default HomepageModalWrapper;



// WEBPACK FOOTER //
// ./src/pages/home/HomeModalWrapper.js